import { send } from '@runway/util-ajax';

const API_BASE_URL = '/privium/enrollment';
const API_REQUEST_TIMEOUT = 10000;

function makeRequest(url) {
    return send(url, {
        method: 'HEAD',
        timeout: API_REQUEST_TIMEOUT
    });
}

export async function validatePriviumNumber(number, apiBaseUrl = API_BASE_URL) {
    return makeRequest(`${apiBaseUrl}/validate-privium-number?number=${number}`);
}

export async function validateDateOfBirth(dob, apiBaseUrl = API_BASE_URL) {
    return makeRequest(`${apiBaseUrl}/validate-date-of-birth?date=${dob}`);
}

export async function validateEmailAddress(email, apiBaseUrl = API_BASE_URL) {
    const emailAddress = encodeURIComponent(email);

    await makeRequest(`${apiBaseUrl}/validate-email-existence?emailAddress=${emailAddress}`);
}
